<template>
    <div class="about">
      <Header 
        title="Customize seu Loadout" 
        subtitle="Jogue em nossos servers com suas skins favoritas!"
      ></Header>
      <div class="container">

        <div class=" text-light mt-3">
          <div class="row">
            <div class="col-3">
              <LoadoutCategories :currentCategory="currentCategory" @onMenuClick="onMenuClick" />
            </div>
            <div class="col-9">
              <div class="row">
                <div class="col-12" v-if="currentLoadout">
                  
                  <h1>Loadout</h1>
                  <!-- {{ currentLoadout }} -->
                </div>
                <div class="col-12">
                  <button v-if="currentWeaponInternal != ''" @click="currentWeaponInternal = ''" class="btn btn-secondary mb-3">Voltar</button>
                  
                  <div class="row" v-if="currentWeaponInternal == ''">
                    <div v-for="weapon in defaultSkinsToShow" :key="weapon.id" class="col-4">
                      <SkinItem :weapon="weapon" @onSelect="onSelectCategory" :class="{ 'border-success': currentLoadout.skins.find(s => s.weapon_defindex.toString() === weapon.weapon_defindex.toString()) }" />
                    </div>
                  </div>
                  
                  <div class="row" v-if="currentWeaponInternal != ''">
                    <div v-for="skin in skinsToShow" :key="skin.id" class="col-4">
                      
                      <SkinItem :weapon="skin" @onSelect="onSelectSkin" :class="{ 'border-success': currentLoadout.skins.find(s => s.weapon_paint_id.toString() === skin.paint_index.toString()) }" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SkinModal v-if="currentSkin" :currentSkin="currentSkin" :currentWeapon="currentWeaponInternal" :showClose="true" @onClose="currentSkin = null" :loadout="currentLoadout" @onRemoveFromLoadout="onRemoveFromLoadout" />
      </div>
    </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import lang from '@/lang/en.json'
  import skins from '@/json/skins/skins.json'
  import defaultSkins from '@/json/defaults/en-defaults.json'
  import SkinItem from '@/components/SkinItem.vue'
  import SkinModal from '@/components/SkinModal.vue'
  import LoadoutCategories from '@/components/LoadoutCategories.vue'

  import skinsService from '@/services/skins.service.js'

  export default {
    name: 'Loadout',
    metaInfo: {
      title: 'Loadout'
    },
    computed: {
      isLocal: function() {
        return window.location.hostname == "queota.club";
      },
      lang: function() {
        return lang;
      },
      skins: function() {
        return skins;
      },
      skinsToShow: function() {
        // skins.filter(skin => skin.category.id === 'csgo_inventory_weapon_category_pistols')
        return this.skins.filter(skin => skin.weapon.id === this.currentWeaponInternal);
      },
      categories: function() {
        // "category": {
        //   "id": "csgo_inventory_weapon_category_pistols",
        //   "name": "Pistols"
        // },
        return this.skins.map(skin => skin.category).filter((value, index, self) => self.findIndex(t => t.id === value.id) === index);
      },
      weaponNames: function() {
        return this.skins.map(skin => skin.weapon.id).filter((value, index, self) => self.findIndex(t => t.id === value.id) === index);
      },
      weaponsPerCategory: function() {
        // return this.skins.map(skin => { return {
        //   weapon: skin.weapon.id,
        //   category: skin.category.id,
        //   skins: this.skins.filter(s => s.weapon.id === skin.weapon.id)
        // }})
        return []
      },
      defaultSkinsToShow: function() {
        return defaultSkins.filter(weapon => weapon.weapon_type == this.currentCategoryInternal)
        // .map(skin => {

          // if (skin.weapon_type == type) {

        // defaultsObject.forEach(weapon => {
        //     if (weapon.weapon_type == type) {
        //         const skinWeapon = selectedSkins.find(element => {
        //             if (element.weapon_defindex == weaponIds[weapon.weapon_name]) {
        //                 return true
        //             }
        //             return false
        //         })                 

        //         if (typeof skinWeapon != 'undefined') {
        //             changeSkinTemplate(weapon, langObject, selectedKnife)
        //             changeSkinCard(weapon, skinWeapon)
        //         } else {
        //             defaultsTemplate(weapon, langObject, lang)
        //         }        
        //     }
        // })
      }
    },
    data () {
      return {
        servers: null,
        currentCategory: '',
        currentCategoryInternal: '',
        currentWeaponInternal: '',
        currentSkin: null,
        currentLoadout: null
      }
    },
    methods: {
      onMenuClick(category) {
        this.currentCategory = category

        switch (category) {
          case 'knives':
            this.currentCategoryInternal = 'sfui_invpanel_filter_melee'
            break
          case 'gloves':
            this.currentCategoryInternal = 'sfui_invpanel_filter_gloves'
            this.currentWeaponInternal = ''
            break
          case 'pistols':
            this.currentCategoryInternal = 'csgo_inventory_weapon_category_pistols'
            this.currentWeaponInternal = ''
            break
          case 'rifles':
            this.currentCategoryInternal = 'csgo_inventory_weapon_category_rifles'
            this.currentWeaponInternal = ''
            break
          case 'utility':
            this.currentCategoryInternal = 'csgo_inventory_weapon_category_utility'
            this.currentWeaponInternal = ''
            break
          case 'SMGs':
            this.currentCategoryInternal = 'csgo_inventory_weapon_category_smgs'
            this.currentWeaponInternal = ''
            break
          case 'heavy':
            this.currentCategoryInternal = 'csgo_inventory_weapon_category_heavy'
            this.currentWeaponInternal = ''
            break
          case 'musicKits':
            // this.currentCategoryInternal = 'csgo_inventory_weapon_category_music_kits'
            break
          case 'ctAgents':
            // this.currentCategoryInternal = 'sfui_invpanel_filter_t'
            break
          case 'tAgents':
            // this.currentCategoryInternal = 'sfui_invpanel_filter_ct'
            break
          default:
            // this.currentCategoryInternal = ''
            break
        }
      },
      onSelectCategory(weapon) {
        this.currentWeaponInternal = weapon.weapon_name
      },
      onSelectSkin(skin) {
        this.currentSkin = skin
      },
      async onRemoveFromLoadout() {
        this.currentLoadout = (await new skinsService(this.$http, this.currentUser.steamid).getSkins()).data.data
        // console.log(this.currentLoadout)
      },
    //   initialize() {
    //     this.$http
    //       .get('pug_servers.json')
    //       .then(response => (this.servers = response.data))
        
    //   }

    },
    async mounted () {
    //   this.initialize()
      try {
        this.currentLoadout = (await new skinsService(this.$http, this.currentUser.steamid).getSkins()).data.data
      } catch (error) {
        this.$toast.error('Erro ao carregar loadout')
        this.$router.push('/')
      }
      
    },
    components: {
      Header,
      SkinItem,
      SkinModal,
      LoadoutCategories
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  </style>
  